module.exports = __webpack_public_path__ + "img/code.a9129790.png";